module.exports = __webpack_public_path__ + "img/ipcdc - Copy.ef733a2e.jpg";